import { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from '../../api/axios';
import { decryptFromBackend } from "../../utils/urlDecryptor";
import BtmButton from "./Components/BtmButton";
import FullscreenLoading from "./Components/FullScreenLoader";


const AddressPage = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const {prescriptionId, token} = useParams<{prescriptionId: string, token: string}>();
    const decryptedToken = useMemo(() => {
        if (!token) return '';
        try {
            return decryptFromBackend(token);
        } catch (err) {
            console.error('Failed to decrypt token:', err);
            return '';
        }
    }, [token]);
    // const queryparams = new URLSearchParams(location.search);
    // const prescriptionId = queryparams.get('prescriptionid');
    const {addressState, nameState, phoneState, noteState, latState, lngState} = location.state || {};

    //user data
    const storedData = sessionStorage.getItem('userData');
    const userDataDefault = storedData ? JSON.parse(storedData) : {};

    const [userData, setUserData] = useState(userDataDefault);
    
    // const token = useState<string>(userData?.token || '');
    

    //maps
    const mapRef = useRef<HTMLDivElement>(null);
    const inputRef = useRef<HTMLInputElement>(null);
    // Jakarta
    const defaultLat = -6.200000;
    const defaultLng = 106.816666;
    const [map, setMap] = useState<google.maps.Map>();
    const [marker, setMarker] = useState<google.maps.Marker>();
    const [lat, setLat] = useState<number>(
        latState !== undefined && latState !== null && !isNaN(Number(latState))
            ? Number(latState)
            : defaultLat
    );
    
    const [lng, setLng] = useState<number>(
        lngState !== undefined && lngState !== null && !isNaN(Number(lngState))
            ? Number(lngState)
            : defaultLng
    );

    const [address, setAddress] = useState(addressState || '');

    //input
    const [name, setName] = useState(nameState || '');
    const [phone, setPhone] = useState(phoneState || '');
    const [note, setNote] = useState(noteState || '');
    const formReady = name && phone && note && address;

    

    useEffect(() => {
        if (mapRef.current && inputRef.current) {
            const center = { lat: lat, lng: lng };
            const mapInstance = new google.maps.Map(mapRef.current, {
                center,
                zoom: 14,
                mapTypeControl: false,
                streetViewControl: false,
            });
            const markerInstance = new google.maps.Marker({
                position: center,
                map: mapInstance,
                draggable: false,
                clickable: false,
                icon: {
                    url: "/images/pin2.png", 
                    scaledSize: new google.maps.Size(60, 60), 
                    anchor: new google.maps.Point(30, 60), 
                },
            });              

            const autocomplete = new google.maps.places.Autocomplete(inputRef.current as HTMLInputElement);
            autocomplete.bindTo("bounds", mapInstance);
            autocomplete.setFields(["name","geometry", "formatted_address"]);

            autocomplete.addListener("place_changed", () => {
                const place = autocomplete.getPlace();
                if (!place.geometry) return;
    
                const location = place.geometry?.location;
    
                const formatted_address = place.name + ' - ' + place.formatted_address
    
                if (location) {
                    mapInstance.setCenter(location);
                    mapInstance.setZoom(16);
                    markerInstance.setPosition(location);
    
                    // Dapatkan lat dan lng dari lokasi
                    const lat = location.lat();
                    const lng = location.lng();
                    setLat(lat);
                    setLng(lng);
                    setAddress(formatted_address || '');
    
                }
    
            });

            google.maps.event.addListener(mapInstance, 'drag', () => {
                const center = mapInstance.getCenter();
                if (!center) return;

                const lat = center.lat();
                const lng = center.lng();

                setLat(lat);
                setLng(lng);

                markerInstance.setPosition(center);

                const geocoder = new google.maps.Geocoder();
                geocoder.geocode({ location: center }, (results, status) => {
                    if (status === 'OK' && results && results[0]) {
                        setAddress(results[0].formatted_address);
                        if (inputRef.current) {
                            inputRef.current.value = results[0].formatted_address;
                        }
                    }
                });
            });
    
            setMap(mapInstance);
            setMarker(markerInstance);
        }
    }, [addressState]);



    const handleSave = async () => {
        await saveAddress();
        await fetchUserData();
    };

    const handleBack = () => {
        navigate(`/e-prescription/${prescriptionId}`)
    }

    const saveAddress = async () => {
        try {
            setLoading(true);
            const response = await axios.post(`prescription/save-address`, {
                prescription_id : prescriptionId,
                recipient_name: name,
                recipient_phone: phone,
                recipient_address: address,
                recipient_note: note,
                lat: lat,
                lng:lng,
            }, {
            headers: {
                Authorization: `Bearer ${decryptedToken}`,
            }
            });

            const res = response.data;
            if(res.status === 'Success')
            {
                setLoading(false);
                navigate(`/e-prescription/checkout/${prescriptionId}/${token}`,{
                    state: {
                        addressState: address,
                        nameState: name,
                        phoneState: phone,
                        noteState: note,
                        latState: lat,
                        lngState: lng
                    }
                })
            }
            else {
                setLoading(false);
            }
            
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const fetchUserData = async () => {
        try {
            const response = await axios.post(`users`, null, {
            headers: {
                Authorization: `Bearer ${decryptedToken}`,
            },
            });

            const data = response.data.data;
            sessionStorage.setItem('userData', JSON.stringify(data));
            setUserData(data);
        } catch (error) {
            console.error('Error posting data:', error);
        }
    };


    return (
        <div className="min-h-screen bg-white pb-20">
            {loading && <FullscreenLoading message="Sedang menyimpan data..."/>}
            <div className="relative h-screen w-full">
                {/* Google Maps */}
                <div ref={mapRef} className="absolute inset-0 z-0" style={{ bottom: '410px' }} />

                {/* NAV di atas Google Maps */}
                <div className="absolute top-4 left-4 z-10">
                    <button
                        onClick={handleBack}
                        className="text-black bg-white p-2 rounded-full shadow"
                    >
                        <img
                            src="/images/leading-actions.svg"
                            alt="Hapus"
                            className="w-8 h-8"
                        />
                    </button>
                </div>



                {/* Card Floating di bawah */}
                <div className="absolute bottom-0 left-0 right-0 z-10 p-0">
                    <div className="bg-white rounded-t-3xl shadow-lg p-4">
                        <div className="flex items-center justify-between mb-2">
                            <h2 className="text-base font-semibold">Pilih Lokasi</h2>
                            
                            <div className="flex items-center space-x-2">
                                <div className="relative">
                                    <input
                                        ref={inputRef}
                                        type="text"
                                        placeholder="Cari"
                                        className="pl-8 pr-2 py-1 text-xs border rounded-full w-32 focus:w-52 transition-all duration-300"
                                    />
                                    <svg
                                        className="absolute left-2 top-1/2 transform -translate-y-1/2 h-3.5 w-3.5 text-gray-400"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-4.35-4.35M16 10a6 6 0 11-12 0 6 6 0 0112 0z" />
                                    </svg>
                                </div>

                            </div>
                        </div>

                        
                        <div className="text-sm mb-4">
                            <div className="flex items-start gap-2">
                                <img
                                src="/images/pin1.png"
                                alt="Pin Lokasi"
                                className="w-8 h-8 mt-1"
                                />
                                <p className="text-gray-500 text-sm">
                                {address || "Lokasi belum dipilih. Silakan cari dan pilih lokasi dengan mengatur pin pada peta."}
                                </p>
                            </div>
                        </div>



                        <div className="mb-3">
                            <label className="text-sm font-medium text-gray-700">Nama Penerima</label>
                            <input
                            type="text"
                                placeholder="Masukan Nama Penerima"
                                className="w-full border rounded-full p-2 text-sm mt-1"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                maxLength={50}
                            />

                        </div>

                        <div className="mb-3">
                            <label className="text-sm font-medium text-gray-700">Nomor Telepon</label>
                            <input
                                type="text"
                                placeholder="Masukan Nomor Telepon"
                                className="w-full border rounded-full p-2 text-sm mt-1"
                                value={phone}
                                onChange={(e) => {
                                    const onlyNumber = e.target.value.replace(/\D/g, "");
                                    setPhone(onlyNumber.slice(0, 15));
                                }}
                                inputMode="numeric"
                                maxLength={15}
                            />
                        </div>

                        <div className="mb-4">
                            <label className="text-sm font-medium text-gray-700">Alamat Lengkap</label>
                            <input
                                type="text"
                                placeholder="Masukan Alamat Lengkap"
                                className="w-full border rounded-full p-2 text-sm mt-1"
                                value={note}
                                onChange={(e) => setNote(e.target.value)}
                                maxLength={255}
                            />
                        </div>
                        <BtmButton disabled={!formReady} onClick={handleSave} label="Simpan" />
                    </div>
                </div>
            </div>
        </div>
    );

};

export default AddressPage;